// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pMOrn","label":"styles_label__bf56A"};